
class Monitoring.Views.LabelTreeView extends Backbone.View
  template: JST["backbone/templates/monitoring/label_admin/label_tree"]

  defaults:
    readOnly: false

  initialize: (@options = {}) ->
    @options = _.defaults(@options, @defaults)
    @labels = @options.labels;
    @removed_labels = []
    @removed_keywords = []

  render: =>
    @$el.html(@template(labels: @labels.toJSON()))
    @_updateLabelTree()
    return this

  _updateLabelTree: =>
    @$el.find('#labels-tree').empty()

    options =
      json_data:
        data:
          data:
            title: 'Tags'
            icon: 'root'
          attr:
            rel: 'root'
          children: @labels.toTreeJSON()
          state: 'open'
      types:
        types:
          root:
            valid_children: 'label'
            start_drag: false
            move_node: false
            delete_node: false
            remove: false
          label: {}
          keyword:
            valid_children: 'none'
            start_drag: false
            move_node: false
      contextmenu:
        items: (node) ->
          type = node.attr('rel')
          menu = {}
          if type != 'root'
            menu['rename'] =
              label: 'Rename'
              action: (node) -> this.rename(node)
              separator_after: true
          if type == 'label' or type == 'keyword'
            menu['remove'] =
              label: 'Remove'
              action: (node) -> this.remove(node)
              separator_after: true
          if type == 'label' or type == 'root'
            menu['create_tag'] =
              label: 'Add tag'
              action: (node) -> this.create(node, 'last', {attr: {rel: 'label'}, data: {title: 'New tag'}})
          if type == 'label'
            menu['create_keyword'] =
              label: 'Add keyword'
              action: (node) -> this.create(node, 0, {attr: {rel: 'keyword'}, data: {title: 'New keyword', icon: 'keyword'}})
          return menu
      sort: (a, b) =>
        a = $(a)
        b = $(b)
        type_a = @_getNodeType(a)
        type_b = @_getNodeType(b)
        if type_a == type_b
          return if @_getNodeName(a) > @_getNodeName(b) then 1 else -1
        else
          return if type_a > type_b then 1 else -1
      ui:
        select_limit: 1

    if @options.readOnly
      options.plugins = ['themes', 'json_data', 'types', 'sort', 'ui']
    else
      options.plugins = ['themes', 'json_data', 'types', 'dnd', 'contextmenu', 'crrm', 'sort', 'ui']

    @tree = @$el.find('#labels-tree').jstree(options)

    @tree.bind('loaded.jstree', () => @_updateTreeJSON();@deactivateOnBeforeUnloadEvent())
    @tree.bind('create.jstree', @_updateTreeJSON)
    @tree.bind('rename.jstree', @_updateTreeJSON)
    @tree.bind('move_node.jstree', @_updateTreeJSON)
    @tree.bind('remove.jstree', (e, data) =>
      node = data.rslt.obj
      if @_getNodeType(node) == 'label'
        @removed_labels.push(@_getNodeId(node))
      else if @_getNodeType(node) == 'keyword'
        label_id = @_getNodeId(data.rslt.parent)
        @removed_keywords[label_id] = @removed_keywords[label_id] or []
        @removed_keywords[label_id].push(@_getNodeId(node))

      @_updateTreeJSON()
    )


  _updateTreeJSON: =>
    @_activateOnBeforeUnloadEvent()
    @$el.find('#fields').html('')

    @tree.find('li[rel=label]').each((index, label) =>
      label = $(label)
      # Label fields
      @$el.find('#fields').append(@_createLabelField(index, 'id', @_getNodeId(label))) if @_getNodeId(label) >= 0
      @$el.find('#fields').append(@_createLabelField(index, 'name', @_getNodeName(label)))

      # Keywords
      label.children('ul').children('li[rel=keyword]').each((kw_index, keyword) =>
        keyword = $(keyword)
        @$el.find('#fields').append(@_createLabelKeywordField(index, kw_index, 'id', @_getNodeId(keyword))) if @_getNodeId(keyword) >= 0
        @$el.find('#fields').append(@_createLabelKeywordField(index, kw_index, 'name', @_getNodeName(keyword)))
      )

      # Removed keywords
      kw_index = label.children('ul').children('li[rel=keyword]').length
      _.each(@removed_keywords[@_getNodeId(label)], (keyword_id) =>
        @$el.find('#fields').append(@_createLabelKeywordField(index, kw_index, 'id', keyword_id))
        @$el.find('#fields').append(@_createLabelKeywordField(index, kw_index, '_destroy', true))
        kw_index++
      )

      # Parent/child relationship
      if label.parent().parent().attr('id')
        parent = label.parent().parent()
        @$el.find('#fields').append(@_createLabelParentField(index, 'parent_name', @_getNodeName(parent)))
        @$el.find('#fields').append(@_createLabelParentField(index, 'child_name', @_getNodeName(label)))
    )

    # Removed labels
    index = @tree.find('li[rel=label]').length
    _.each(@removed_labels, (label_id) =>
      @$el.find('#fields').append(@_createLabelField(index, 'id', label_id))
      @$el.find('#fields').append(@_createLabelField(index, '_destroy', true))
      index++
    )

  _getNodeName: (node) ->
    return node.children('a').text().trim()

  _getNodeId: (node) ->
    id = node.attr('id')
    if not id
      return undefined
    if @_getNodeType(node) == 'label'
      return id.replace('label_', '')
    else
      return id.replace('keyword_', '')

  _getNodeType: (node) ->
    return node.attr('rel')

  _createLabelField: (index, name, value) ->
    input = $('<input type="hidden">')
    input.attr('name', "keepcon_topic[labels_attributes][#{index}][#{name}]")
    input.attr('id', "keepcon_topic_labels_attributes_#{index}_#{name}")
    input.val(value)

  _createLabelKeywordField: (index, kw_index, name, value) ->
    input = $('<input type="hidden">')
    input.attr('name', "keepcon_topic[labels_attributes][#{index}][keywords_attributes][#{kw_index}][#{name}]")
    input.attr('id', "keepcon_topic_labels_attributes_#{index}_keywords_attributes_#{kw_index}_#{name}")
    input.val(value)

  _createLabelParentField: (index, name, value) ->
    input = $('<input type="hidden">')
    input.attr('name', "labels[#{index}][#{name}]")
    input.val(value)


  _activateOnBeforeUnloadEvent: ->
    window.onbeforeunload = (e) ->
      message = "You have unsaved tags or keywords. Changes will be lost."
      event = e or window.event
      event.returnValue = message if event
      return message

  deactivateOnBeforeUnloadEvent: ->
    window.onbeforeunload = undefined;